import { AxiosResponse } from 'axios';
import { DataWizardAct, SignatoriesVM, SignatureActVM } from 'civil-status/view-models/step-form';
import { HttpResponse } from 'shell/models/http-response';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { transformerDocument } from './transformer-document';
import { transformerSignatories } from './transformer-signatories';
import { TYPE_DOCUMENT_PROCESSO_VERBALE } from 'civil-status/constants/type-document-processo-verbale';

export const transformerActSignature = (
  response: AxiosResponse<HttpResponse<DataWizardAct>>
): SignatureActVM => {
  const castedResponseEvento = response.data?.payload?.evento || {};
  const castedResponseSoggettoList = response.data?.payload?.soggettoList || [];
  const castedResponseFirmatariList = response.data?.payload?.firmatariList || [];
  const castedResponseAllegatoList = response.data?.payload?.allegatoList || [];
  const castedResponseStatoCivile = response.data?.payload?.statoCivile || {};

  const signatories: Array<SignatoriesVM> = transformerSignatories(
    castedResponseSoggettoList,
    castedResponseFirmatariList
  );

  const filtredAllegatoList = castedResponseAllegatoList.filter(
    (item) => item.tipoAllegato === TYPE_DOCUMENT_PROCESSO_VERBALE
  );

  const document: TypeFile = transformerDocument(filtredAllegatoList[0]);

  return {
    idAnsc: castedResponseEvento.idAnsc || '',
    idState: castedResponseEvento.codiceStatoEvento
      ? Number.parseInt(castedResponseEvento.codiceStatoEvento, 10)
      : undefined,
    signatories,
    document,
    operatorName: castedResponseEvento.operatoreNome || '',
    operatorSurname: castedResponseEvento.operatoreCognome || '',
    idEventoCorrelato: castedResponseStatoCivile.idEventoCorrelato?.toString(),
    allegatoList: castedResponseAllegatoList.filter(
      (item) => item.tipoAllegato !== TYPE_DOCUMENT_PROCESSO_VERBALE
    ),
  };
};
